// Flip this to true if you want to see what happens
var PBW_DEBUG = false;

function pbwLog() {
  if (!PBW_DEBUG) return;
  // eslint-disable-next-line no-console
  console.log.apply(
    console,
    ["[price-by-weight]"].concat(Array.from(arguments))
  );
}

// Helper to format money using theme settings
function formatMoneyWithTheme(cents) {
  var format =
    (window.theme &&
      window.theme.settings &&
      window.theme.settings.money_with_currency_format) ||
    "${{amount}}";

  return formatMoney(cents, format).replace(",", " ");
}

function computePriceByWeightLabel(options) {
  var amount = options.amount; // variant.price (cents)
  var weight = options.weight; // variant.weight (grams)
  var weightUnit = options.weightUnit; // "g" or "kg"
  var unitPriceFlag = options.unitPriceFlag;
  var inPaketCollection = options.inPaketCollection;
  var piecesPerPack = options.piecesPerPack;

  var isUnitPrice = unitPriceFlag || inPaketCollection;

  pbwLog("computePriceByWeightLabel input:", {
    amount,
    weight,
    weightUnit,
    unitPriceFlag,
    inPaketCollection,
    piecesPerPack,
  });

  // 1) Unit-price mode or "paket" -> KR/ST
  if (isUnitPrice) {
    if (piecesPerPack && piecesPerPack > 0) {
      var pricePerPiece = amount / piecesPerPack;
      return formatMoneyWithTheme(pricePerPiece) + "/st";
    }
    return formatMoneyWithTheme(amount) + "/st";
  }

  // 2) Weight-based logic
  if (!weight || weight <= 0) {
    return formatMoneyWithTheme(amount) + "/st";
  }

  if (weightUnit === "kg") {
    var pricePerKg = (amount * 1000) / weight;
    return formatMoneyWithTheme(pricePerKg) + "/kg";
  }

  if (weightUnit === "g") {
    var pricePerHg = (amount * 100) / weight;
    return formatMoneyWithTheme(pricePerHg) + "/hg";
  }

  // Fallback
  return formatMoneyWithTheme(amount) + "/st";
}

// Global helper to be called when variant changes
window.updatePriceByWeightForSection = function (variant, sectionId) {
  if (!variant || !sectionId) {
    pbwLog("Missing variant or sectionId", { variant, sectionId });
    return;
  }

  pbwLog("updatePriceByWeightForSection called", { variant, sectionId });

  var container = document.querySelector(
    '.price-by-weight[data-section-id="' + sectionId + '"]'
  );

  if (!container) {
    pbwLog("No .price-by-weight container found for section", sectionId);
    return;
  }

  var amountEl = container.querySelector(".amount");
  if (!amountEl) {
    pbwLog("No .amount element inside price-by-weight for section", sectionId);
    return;
  }

  var unitPriceFlag =
    container.dataset.unitPriceFlag &&
    container.dataset.unitPriceFlag.toString().toLowerCase() === "true";

  var inPaketCollection =
    container.dataset.inPaketCollection &&
    container.dataset.inPaketCollection.toString().toLowerCase() === "true";

  var piecesPerPack = parseInt(container.dataset.piecesPerPack || "0", 10);
  if (isNaN(piecesPerPack)) piecesPerPack = 0;

  var weightUnit = container.dataset.weightUnit || "g";

  // NOTE: depends on what your theme puts on the JS variant object
  var jsWeight = variant.weight || 0; // you said this exists: weight: 2000

  var label = computePriceByWeightLabel({
    amount: variant.price,
    weight: jsWeight,
    weightUnit: weightUnit,
    unitPriceFlag: unitPriceFlag,
    inPaketCollection: inPaketCollection,
    piecesPerPack: piecesPerPack,
  });

  pbwLog("Computed label:", label);
  amountEl.textContent = label;
};
